import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'no-results',
  standalone: true,
  imports: [CommonModule, MatButtonModule],
  template: `
    <div class="tw-flex tw-flex-col tw-items-center tw-justify-center tw-gap-4 tw-py-8">
      <img src="../images/no-results.svg" alt="No results found">
      <h3>No results found</h3>
      <p class="tw-block tw-w-1/2 tw-text-center tw-text-gray-600 tw-text-wrap">
        {{ message }}
      </p>
      @if (showAction) {
        <button mat-button
          color="primary"
          (click)="action.emit()">
          {{ actionText }}
        </button>
      }
    </div>
  `,
  styles: `
    :host {
      display: block;
      width: 100%;
    }
  `
})
export class NoResultsComponent {
  @Input() message = 'No items match your search criteria. Try to search by another keyword.';
  @Input() actionText = 'Clear results';
  @Input() showAction = true;
  @Output() action = new EventEmitter<void>();
} 